import React, { useRef, useState, useEffect } from "react";
import "../CounterFactor.scss";
import "./CounterFactorKol.scss";
import DynaInput from "../../UI/DynaInput/DynaInput";
import ChooseBank from "./ChooseBank/ChooseBank";
import ChooseCash from "./ChooseCash/ChooseCash";
import ChooseDemands from "./ChooseDemands/ChooseDemands";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { DateObject } from "react-multi-date-picker";
import DataTable from "../../../Assets/Images/calendar-1 1.svg";
import {
  parseToEnRemoveComma,
  formatToPersianAddComma,
} from "../../../utils/CommaSeparator";
import _axios from "../../../httpService";
import { prefixUrl } from "../../../utils/utilsData";
import { toast } from "react-toastify";
import numericFunction from "../../../utils/NumericFunction";
import CounterFactorData from "../CounterFactorData";
import { useNavigate } from "react-router-dom";

const CounterFactorKol = ({
  sendData,
  setSendData,
  initialData,
  componentData,
  setComponentData,
}) => {
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    calendar: "persian",
  };
  const todayDate = new Date().toLocaleDateString("fa-IR", options);
  const dateCal = useRef(null);
  let [date, setDate] = useState(new DateObject());
  const navigateTo = useNavigate();
  const typePaymentData = [
    { label: "واریز به حساب", value: "bank" },
    { label: "نقدی", value: "cash" },
    { label: "مطالبات", value: "demands" },
  ]; //نوع پرداخت

  useEffect(() => {
    // اگه سری اول خالی بود ینی بک اند چیزی نفرستاده و من باید تاریخ امروز رو بزارم جای  مقدار دیت
    if (sendData.date === "") {
      setSendData({ date: todayDate });
    }
  }, [sendData]);

  useEffect(() => {
    // setSendData({ paidPrice: "" });
    setComponentData({ reload: Math.random() });
  }, [sendData?.paymentType]);

  const submitHandler = (e) => {
    let temp = { ...sendData };
    temp.date = numericFunction.p2e(temp.date); //تبدیل فرمت فارسی اعداد به انگلیسی
    e.preventDefault();
    const data = {
      request: "factorConfirm",
      factorData: temp,
    };

    if (temp.sumTotalInvoice !== +temp.paidPrice) {
      toast.error("مبلغ پرداختی با مبلغ فاکتور برابر نیست!.");
      return;
    }
    debugger;
    if (temp.paymentType === "bank" && temp.bankId === "") {
      toast.error("اطلاعات بانک یافت نشد");
      return;
    }
    if (temp.paymentType === "cash" && temp.fund === "") {
      toast.error("اطلاعات صندوق یافت نشد");
      return;
    }
    if (temp.paymentType === "demands" && temp.customerId === "") {
      toast.error("اطلاعات مشتری یافت نشد");
      return;
    }
    if (
      temp.productsTableData.length === 0 &&
      temp.servicesTableData.length === 0
    ) {
      toast.error("باید حداقل یک کالا یا خدمات انتخاب کنید");
      return;
    }

    _axios
      .post(prefixUrl() + `/counterOfficeFactor/`, data)
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
          if (sendData?.mode === "add") {
            setSendData(CounterFactorData.initialSendData);
            setComponentData(CounterFactorData.componentData);
          }else{
            toast.success(response.data.message);
            // debugger
            navigateTo(-1);
          }
        } else {
          toast.error(response.data.message);
        }
      });
  };

  return (
    <div className="factorWrapper__">
      <form className="counterFactorForm__">
        <div className="Date">
          <label>تاریخ </label>
          <DatePicker
            onChange={(date) => {
              if (date) {
                setSendData({ date: date.toLocaleString() });
              } else {
                setSendData({ date: "" });
              }
            }}
            ref={dateCal}
            calendar={persian}
            className="Date"
            placeholder="تاریخ ثبت را انتخاب کنید"
            locale={persian_fa}
            value={sendData.date || todayDate}
            calendarPosition="bottom-right"
            hideOnScroll
          />
          <div className="imageDate">
            <img src={DataTable} alt="" />
          </div>
        </div>
        <DynaInput
          typeMode={"select"}
          label={"نوع فاکتور"}
          className={"solid-login-type inputClass__"}
          selectOption={typePaymentData}
          value={
            sendData.paymentType === "" || sendData.paymentType === undefined
              ? "bank"
              : sendData.paymentType
          }
          onChange={(e) => {
            setSendData({ paymentType: e.target.value });
          }}
        />
        {sendData.paymentType === "bank" && (
          <ChooseBank
            sendData={sendData}
            setSendData={setSendData}
            initialData={initialData}
            componentData={componentData}
            setComponentData={setComponentData}
          />
        )}
        {sendData.paymentType === "cash" && (
          <ChooseCash
            sendData={sendData}
            setSendData={setSendData}
            initialData={initialData}
            componentData={componentData}
            setComponentData={setComponentData}
          />
        )}
        {sendData.paymentType === "demands" && (
          <ChooseDemands
            sendData={sendData}
            setSendData={setSendData}
            initialData={initialData}
            componentData={componentData}
            setComponentData={setComponentData}
          />
        )}
        <DynaInput
          label={"تخفیف"}
          placeholder={"مقدار تخفیف را وارد کنید"}
          typeMode={"input"}
          type={"text"}
          className={"solid-login-type inputClass__"}
          value={formatToPersianAddComma(sendData.discount)}
          onChange={(e) => {
            // Remove any non-numeric characters
            const enteredValue = parseToEnRemoveComma(e.target.value);
            const numericValue = enteredValue.replace(/[^0-9]/g, "");
            setSendData({ discount: numericValue });
            setComponentData({ reload: Math.random() });
          }}
        />
        <DynaInput
          label={"توضیحات"}
          placeholder={"توضیحات خود را وارد کنید"}
          typeMode={"textarea"}
          style={{ height: 70 }}
          className={"solid-login-type inputClass__"}
          value={sendData.description}
          onChange={(e) => setSendData({ description: e.target.value })}
        />
        <ul className="detailsFormList__">
          <li>
            جمع کالا و خدمات
            <span>
              {formatToPersianAddComma(sendData.sumOfProductsAndServices)} تومان
            </span>
          </li>
          <li>
            مالیات<span>{formatToPersianAddComma(initialData.tax)}%</span>
          </li>
          <li>
            جمع کل فاکتور
            <span>
              {formatToPersianAddComma(sendData.sumTotalInvoice)} تومان
            </span>
          </li>
          <li>
            مانده فاکتور
            <span>
              {formatToPersianAddComma(sendData.invoiceBalance)} تومان
            </span>
          </li>
        </ul>
        <div className="formButtons__">
          {/* <button className="printButton__" onClick={submitAndPrintHandler}>
            ثبت و پرینت
          </button> */}
          <button className="submitButton__" onClick={submitHandler}>
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
};

export default CounterFactorKol;
